export function getTransactionFiltersFromSearchApiFilter(searchApiFilters, activeExpenseBucketsById = {}) {
    if (!searchApiFilters) {
        return [];
    }
    const filters = [];
    if (searchApiFilters.user_id) {
        filters.push({ field: 'linked_account.user_id', value: searchApiFilters.user_id });
    }
    if (searchApiFilters.category_id) {
        filters.push({ field: 'linked_account.default_category_id', value: searchApiFilters.category_id });
    }
    if (searchApiFilters.manager_id) {
        filters.push({
            field: 'linked_account.user_profile.manager_profile.user_id',
            value: searchApiFilters.manager_id
        });
    }
    if (searchApiFilters.linked_account_ids) {
        filters.push({ field: 'linked_account.id', value: searchApiFilters.linked_account_ids });
    }
    if (searchApiFilters.program_id) {
        filters.push({ field: 'linked_account.parent_linked_account_id', value: searchApiFilters.program_id });
    }
    if (searchApiFilters.vendor_unicode) {
        filters.push({ field: 'vendor', value: searchApiFilters.vendor_unicode });
    }
    if (searchApiFilters.amount) {
        filters.push({ field: 'amount', value: searchApiFilters.amount });
    }
    else if (searchApiFilters.amount_below) {
        filters.push({ field: 'amount', operator: '<', value: searchApiFilters.amount_below });
    }
    else if (searchApiFilters.amount_above) {
        filters.push({ field: 'amount', operator: '>', value: searchApiFilters.amount_above });
    }
    if (searchApiFilters.posted_date_after) {
        filters.push({ field: 'posted_date', operator: '>', value: searchApiFilters.posted_date_after });
    }
    if (searchApiFilters.posted_date_before) {
        filters.push({ field: 'posted_date', operator: '<', value: searchApiFilters.posted_date_before });
    }
    if (searchApiFilters.statement_date_after) {
        filters.push({ field: 'statement_date', operator: '>', value: searchApiFilters.statement_date_after });
    }
    if (searchApiFilters.statement_date_before) {
        filters.push({ field: 'statement_date', operator: '<', value: searchApiFilters.statement_date_before });
    }
    if (searchApiFilters.statement_cycle) {
        filters.push({ field: 'statement_cycle', value: searchApiFilters.statement_cycle });
    }
    if (searchApiFilters.date_after) {
        filters.push({ field: 'date', operator: '>', value: searchApiFilters.date_after });
    }
    if (searchApiFilters.date_before) {
        filters.push({ field: 'date', operator: '<', value: searchApiFilters.date_before });
    }
    if (searchApiFilters.status) {
        filters.push({ field: 'status', value: searchApiFilters.status });
    }
    if (searchApiFilters.resubmittable) {
        filters.push({ field: 'expenses.resubmittable', value: searchApiFilters.resubmittable });
    }
    if (searchApiFilters.expense_tag_bucket_id) {
        filters.push({
            field: 'selected_team_field_tags_by_bucket_id',
            value: Object.keys(searchApiFilters.expense_tag_bucket_id)
                .filter((bucketId) => activeExpenseBucketsById[bucketId] && activeExpenseBucketsById[bucketId].is_team_field)
                .reduce((teamFieldTagsByBucketIdAccumulator, currentBucketId) => {
                teamFieldTagsByBucketIdAccumulator[currentBucketId] = searchApiFilters.expense_tag_bucket_id[currentBucketId];
                return teamFieldTagsByBucketIdAccumulator;
            }, {})
        });
    }
    return filters;
}
